import { render } from "./ProductMassAdd.vue?vue&type=template&id=65a89a0a"
import script from "./ProductMassAdd.vue?vue&type=script&lang=js"
export * from "./ProductMassAdd.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__